module.exports = __webpack_public_path__ + "static/imgs/title-v.84cb9de.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/title-v.png
// module id = yuew
// module chunks = 1